let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '优惠券名称',
        props: 'couponName',
        minWidth: 220,
    },
    {
        label: '优惠券编号',
        props: 'couponNo',
        minWidth: 200,
    },
    {
        label: '优惠券兑换流水号',
        props: 'couponExchangeNo',
        minWidth: 200,
    },
    {
        label: '优惠券品类',
        props: 'couponTypeName',
        minWidth: 180,
    },
    {
        label: '卡券归属',
        props: 'couponBelongName',
        minWidth: 150,
    },
    {
        label: '发放平台',
        props: 'provideChannelName',
        minWidth: 180,
    },
    {
        label: '发放类型',
        props: 'exchangeType',
        minWidth: 180,
        formatter:(row)=>{
            if (row.exchangeType == '01') {
                return '活动报名';
            } else if (row.exchangeType == '02') {
                return '活动分享';
            } else if (row.exchangeType == '03') {
                return '激活用桩';
            } else {
                return '';
            }
        }
    },
    {
        label: '兑换用户',
        props: 'mobile',
        minWidth: 200,
    },
    {
        label: '积分流水号',
        props: 'pointsNo',
        minWidth: 200,
    },
    {
        label: '发放状态',
        props: 'exchangeStatusName',
        minWidth: 90,
    },
    {
        label: '备注',
        props: 'remark',
        minWidth: 130,
    },
    {
        label: '券值/元',
        props: 'prizeAmount',
        minWidth: 130,
    },
    {
        label: '积分兑换数',
        props: 'exchangePoints',
        minWidth: 130,
    },
    {
        label: '扣除积分数',
        props: 'consumePoints',
        minWidth: 130,
    },
    {
        label: '兑换时间',
        props: 'exchangeWhen',
        minWidth: 200,
    },
    {
        label: '兑换成功时间',
        props: 'exchangeSuccessWhen',
        minWidth: 200,
    },
    {
        label: '卡券有效期',
        props: 'expireWhen',
        minWidth: 200,
    },
];

// // 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '优惠券管理'
    },
    {
        type: 'title',
        name: '优惠券发放列表'
    }
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}


// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileDetail',
};

// 路由
pageConfig.listRouter = 'pileList';

pageConfig.reportDetailRouter = 'pileReportDetail';

pageConfig.chargeDetailRouter = 'pileChargeDetail';

pageConfig.repairListDetail = 'repairListDetail';

pageConfig.faultDetail = 'faultDetail';

//维修新增路由
pageConfig.repairAddRouter = 'repairAddDetail';

//维修路由
pageConfig.repairRouter = 'repairDetail';

// 关联账号
pageConfig.relationNum = 'relationNum';

// 详情的面包屑
pageConfig.detailBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '订单管理',
    },
    {
        type: 'router',
        name: '活动订单列表',
        router: 'activityOrderList'
    },
    {
        type: 'title',
        name: '活动订单编辑'
    }
];


pageConfig.formRules = {
    pileCode: [{ required: true, message: '请输入IMEI号', trigger: 'blur' }],
};



export default pageConfig;
